import { OktaAuth } from '@okta/okta-auth-js'

const oktaConfig = {
  issuer: (window as any).env !== undefined ? (window as any).env.REACT_APP_OKTA_ISSUER : 'https://www.dummyissuer.com',
  redirectUri: `${window.location.origin}/implicit/callback`,
  pkce: true,
}

export const oktaAuth = new OktaAuth(oktaConfig)
